import { create } from 'zustand';

export const useUiStore = create((set) => ({
  breadcrumbsOptions: [],
  isSidebarCollapsed: false,
  isTrialPaywallOpen: false,
  isContactUsOpen: false,
  isOnboardingVideoOpen: false,
  sectionsListTranslateX: 0,
  videoPlayerHeight: 0,

  setBreadcrumbsOptions: (breadcrumbsOptions) => set({ breadcrumbsOptions }),
  toggleSidebar: () =>
    set((state) => ({ isSidebarCollapsed: !state.isSidebarCollapsed })),
  setTrialPaywallOpen: (isTrialPaywallOpen) => set({ isTrialPaywallOpen }),
  setContactUsOpen: (isContactUsOpen) => set({ isContactUsOpen }),
  setOnboardingVideoOpen: (isOnboardingVideoOpen) => set({ isOnboardingVideoOpen }),
  setSectionsListTranslateX: (sectionsListTranslateX) =>
    set({ sectionsListTranslateX }),
  setVideoPlayerHeight: (videoPlayerHeight) => set({ videoPlayerHeight }),
}));

export const useMeetingViewStore = create((set) => ({
  // minSectionIndex accounts for non-playable sections with zero duration.
  // These sections share the same startTime as the nearest following playable section.
  // When the video is played, the non-playable section becomes active first.
  // However, if the user manually clicks on a section, we must prevent the previous non-playable section from becoming active automatically.
  // Setting minSectionIndex to the index of the clicked section ensures that the clicked section becomes active.
  minSectionIndex: 0,
  timelineMapping: [],
  currentQuestion: null,
  shouldDisableQuestionModalAnimation: false,
  // isVideoPlayerFixedMode is used to determine if the video player should be fixed position with inset 0 (fullscreent emulation)
  isVideoPlayerFixedMode: false,

  setMinSectionIndex: (minSectionIndex) => set({ minSectionIndex }),
  setTimelineMapping: (timelineMapping) => set({ timelineMapping }),
  setCurrentQuestion: (currentQuestion) => set({ currentQuestion }),
  setIsVideoPlayerFixedMode: (isVideoPlayerFixedMode) =>
    set({ isVideoPlayerFixedMode }),
}));
